import { render, staticRenderFns } from "./ChatSettingHome.vue?vue&type=template&id=148823fd&"
import script from "./ChatSettingHome.vue?vue&type=script&lang=js&"
export * from "./ChatSettingHome.vue?vue&type=script&lang=js&"
import style0 from "./ChatSettingHome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports